var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDostalinierdzewnejIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.95 51.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 29.82 .46 29.82 .46 29.35 0 29.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "31.07 24.43 31.07 27.3 31.07 29.08 53.95 5.71 53.95 0 29.18 0 5.28 24.43 28.2 24.43 31.07 24.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "44.04 20.03 31.07 33.26 31.07 33.47 31.07 36.35 28.2 36.35 21.73 36.35 21.73 42.84 28.2 42.84 31.07 42.84 31.07 45.72 31.07 51.16 53.95 27.82 53.95 20.03 44.04 20.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.8 39.56 6.36 42.84 9.8 42.84 9.8 39.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.85 45.72 18.85 33.47 28.2 33.47 28.2 27.3 3.34 27.3 3.34 33.47 12.68 33.47 12.68 45.72 3.34 45.72 3.34 51.89 12.82 51.89 28.2 51.89 28.2 45.72 18.85 45.72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDostalinierdzewnejIcon);
export default __webpack_public_path__ + "static/media/Do stali nierdzewnej_icon.e947ef7a84d1d91656153869fe1f81f1.svg";
export { ForwardRef as ReactComponent };